"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPromotionByPromotionId = exports.claimFreeEntry = exports.resetReward = exports.redeemReward = exports.fetchAllEntries = exports.fetchRewardFreeEntries = exports.getAllDraws = exports.redeemCupon = exports.fetchRedemption = exports.fetchCoupon = exports.fetchEntries = exports.getActiveDrawByPromotionId = exports.getActiveDraw = exports.fetchRewardWithFrequencyCapById = exports.fetchRewardWithFrequencyCap = exports.fetchRewardById = exports.fetchReward = exports.fetchRewardList = exports.fetchHomePageUserRewards = exports.fetchShortListRewards = exports.fetchUserRewards = exports.fetchRewards = void 0;
var types_1 = require("@pbl/pbl-react-core/lib/models/draws/types");
var types_2 = require("@pbl/pbl-react-core/lib/models/reward/types");
var services_1 = require("@pbl/pbl-react-core/lib/services");
var reward_service_1 = require("@pbl/pbl-react-core/lib/services/reward-service");
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var action_type_util_1 = require("../../action-type.util");
var actions_1 = require("../app/actions");
var actions_2 = require("../ledger/actions");
var fetchRewards = function (mobileOnly, featured, type) { return __awaiter(void 0, void 0, void 0, function () {
    var data, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, reward_service_1.RewardService.getRewards(mobileOnly, featured, type)];
            case 1:
                data = _a.sent();
                return [2, data];
            case 2:
                e_1 = _a.sent();
                console.error(e_1);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
exports.fetchRewards = fetchRewards;
var fetchUserRewards = function (mobileOnly, featured, type) { return __awaiter(void 0, void 0, void 0, function () {
    var data, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, reward_service_1.RewardService.getUserRewards(mobileOnly, featured, type)];
            case 1:
                data = _a.sent();
                return [2, data];
            case 2:
                e_2 = _a.sent();
                console.error(e_2);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
exports.fetchUserRewards = fetchUserRewards;
var fetchShortListRewards = function (type) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var featuredRewards, nonFeaturedRewards, rewards, _i, rewards_1, reward, coupon, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 7, , 8]);
                dispatch({
                    type: (0, action_type_util_1.REQUEST)(types_2.GET_REWARD_LIST)
                });
                return [4, reward_service_1.RewardService.getRewards(false, true, type)];
            case 1:
                featuredRewards = _a.sent();
                return [4, reward_service_1.RewardService.getRewards(false, false, type)];
            case 2:
                nonFeaturedRewards = _a.sent();
                rewards = __spreadArray(__spreadArray([], featuredRewards, true), nonFeaturedRewards, true);
                if (!(rewards.length > 0)) return [3, 6];
                _i = 0, rewards_1 = rewards;
                _a.label = 3;
            case 3:
                if (!(_i < rewards_1.length)) return [3, 6];
                reward = rewards_1[_i];
                if (!(reward.type === types_2.RewardType.COUPON)) return [3, 5];
                return [4, (0, exports.fetchCoupon)(reward.key)];
            case 4:
                coupon = _a.sent();
                if (coupon) {
                    reward.remaining = coupon.remaining;
                }
                _a.label = 5;
            case 5:
                _i++;
                return [3, 3];
            case 6:
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_2.GET_REWARD_LIST),
                    payload: rewards
                });
                return [3, 8];
            case 7:
                e_3 = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_2.GET_REWARD_LIST),
                    payload: e_3
                });
                console.error(e_3);
                return [3, 8];
            case 8: return [2];
        }
    });
}); }; };
exports.fetchShortListRewards = fetchShortListRewards;
var fetchHomePageUserRewards = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var featuredRewards, nonFeaturedRewards, rewards, _i, rewards_2, reward, coupon, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 7, , 8]);
                dispatch({
                    type: (0, action_type_util_1.REQUEST)(types_2.GET_REWARD_LIST)
                });
                return [4, reward_service_1.RewardService.getUserRewards(false, true)];
            case 1:
                featuredRewards = _a.sent();
                return [4, reward_service_1.RewardService.getUserRewards(false, false)];
            case 2:
                nonFeaturedRewards = _a.sent();
                rewards = __spreadArray(__spreadArray([], featuredRewards, true), nonFeaturedRewards, true);
                if (!(rewards.length > 0)) return [3, 6];
                _i = 0, rewards_2 = rewards;
                _a.label = 3;
            case 3:
                if (!(_i < rewards_2.length)) return [3, 6];
                reward = rewards_2[_i];
                if (!(reward.type === types_2.RewardType.COUPON)) return [3, 5];
                return [4, (0, exports.fetchCoupon)(reward.key)];
            case 4:
                coupon = _a.sent();
                if (coupon) {
                    reward.remaining = coupon.remaining;
                }
                _a.label = 5;
            case 5:
                _i++;
                return [3, 3];
            case 6:
                dispatch({
                    type: (0, action_type_util_1.SUCCESS)(types_2.GET_REWARD_LIST),
                    payload: rewards
                });
                return [3, 8];
            case 7:
                e_4 = _a.sent();
                dispatch({
                    type: (0, action_type_util_1.FAILURE)(types_2.GET_REWARD_LIST),
                    payload: e_4
                });
                console.error(e_4);
                return [3, 8];
            case 8: return [2];
        }
    });
}); }; };
exports.fetchHomePageUserRewards = fetchHomePageUserRewards;
var fetchRewardList = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var data, e_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, reward_service_1.RewardService.getRewardList('web')];
            case 1:
                data = _a.sent();
                dispatch({
                    type: types_2.GET_REWARD_LIST,
                    payload: data
                });
                return [3, 3];
            case 2:
                e_5 = _a.sent();
                console.error(e_5);
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.fetchRewardList = fetchRewardList;
var fetchReward = function (rewardId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, dispatch({
                        type: types_2.GET_REWARD,
                        payload: reward_service_1.RewardService.fetchRewardDetails(rewardId)
                    })];
            case 1:
                _a.sent();
                return [3, 3];
            case 2:
                error_1 = _a.sent();
                console.error(error_1);
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.fetchReward = fetchReward;
var fetchRewardById = function (rewardId) { return __awaiter(void 0, void 0, void 0, function () {
    var reward, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, reward_service_1.RewardService.fetchRewardDetails(rewardId)];
            case 1:
                reward = _a.sent();
                return [2, reward];
            case 2:
                error_2 = _a.sent();
                console.error(error_2);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
exports.fetchRewardById = fetchRewardById;
var fetchRewardWithFrequencyCap = function (rewardId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, dispatch({
                        type: types_2.GET_REWARD_WITH_FREQUENCY_CAP,
                        payload: reward_service_1.RewardService.getRewardWithFrequencyCap(rewardId)
                    })];
            case 1:
                _a.sent();
                return [3, 3];
            case 2:
                error_3 = _a.sent();
                console.error(error_3);
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.fetchRewardWithFrequencyCap = fetchRewardWithFrequencyCap;
var fetchRewardWithFrequencyCapById = function (rewardId) { return __awaiter(void 0, void 0, void 0, function () {
    var reward;
    return __generator(this, function (_a) {
        try {
            reward = reward_service_1.RewardService.getRewardWithFrequencyCap(rewardId);
            return [2, reward];
        }
        catch (error) {
            console.error(error);
        }
        return [2];
    });
}); };
exports.fetchRewardWithFrequencyCapById = fetchRewardWithFrequencyCapById;
var getActiveDraw = function (promotionId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, dispatch({
                        type: types_2.GET_ACTIVE_DRAW,
                        payload: services_1.PromotionsService.fetchActiveDraw(promotionId)
                    })];
            case 1:
                _a.sent();
                return [3, 3];
            case 2:
                error_4 = _a.sent();
                console.error(error_4);
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.getActiveDraw = getActiveDraw;
var getActiveDrawByPromotionId = function (promotionId) { return __awaiter(void 0, void 0, void 0, function () {
    var error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, services_1.PromotionsService.fetchActiveDraw(promotionId)];
            case 1: return [2, _a.sent()];
            case 2:
                error_5 = _a.sent();
                console.error(error_5);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
exports.getActiveDrawByPromotionId = getActiveDrawByPromotionId;
var fetchEntries = function (drawId) { return __awaiter(void 0, void 0, void 0, function () {
    var error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, services_1.PromotionsService.fetchSecondChanceDrawEntries(drawId)];
            case 1: return [2, _a.sent()];
            case 2:
                error_6 = _a.sent();
                console.error(error_6);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
exports.fetchEntries = fetchEntries;
var fetchCoupon = function (rewardKey) { return __awaiter(void 0, void 0, void 0, function () {
    var error_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, services_1.CodeService.getDetails(rewardKey)];
            case 1: return [2, _a.sent()];
            case 2:
                error_7 = _a.sent();
                console.error(error_7);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
exports.fetchCoupon = fetchCoupon;
var fetchRedemption = function (rewardKey) { return __awaiter(void 0, void 0, void 0, function () {
    var error_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, services_1.FrequencyService.getGlobalFrequency(rewardKey)];
            case 1: return [2, _a.sent()];
            case 2:
                error_8 = _a.sent();
                console.error(error_8);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
exports.fetchRedemption = fetchRedemption;
var redeemCupon = function (rewardKey, errorCallback) { return __awaiter(void 0, void 0, void 0, function () {
    var e_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, services_1.CodeService.redeem(rewardKey)];
            case 1: return [2, _a.sent()];
            case 2:
                e_6 = _a.sent();
                console.error(e_6);
                errorCallback(e_6);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
exports.redeemCupon = redeemCupon;
var getAllDraws = function (promotionId, pageNumber, pageSize) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var error_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, dispatch({
                        type: types_2.GET_ALL_DRAWS,
                        payload: services_1.PromotionsService.getDrawsforPromotionId(promotionId, pageNumber, pageSize)
                    })];
            case 1:
                _a.sent();
                return [3, 3];
            case 2:
                error_9 = _a.sent();
                console.error(error_9);
                return [3, 3];
            case 3: return [2];
        }
    });
}); }; };
exports.getAllDraws = getAllDraws;
var fetchRewardFreeEntries = function (drawId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch({
            type: types_2.FETCH_FREE_ENTRIES,
            payload: services_1.PromotionsService.countFreeEntry(drawId)
        });
        return [2];
    });
}); }; };
exports.fetchRewardFreeEntries = fetchRewardFreeEntries;
var fetchAllEntries = function (drawId) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var allDraws, draw;
    return __generator(this, function (_a) {
        allDraws = getState().reward.allDraws;
        draw = allDraws.find(function (x) { return x.id === drawId; });
        dispatch({
            type: types_2.FETCH_ENTRIES,
            payload: draw ? draw.entries : 0
        });
        return [2];
    });
}); }; };
exports.fetchAllEntries = fetchAllEntries;
var redeemReward = function (rewardId, quantity, successCallback, errorCallback) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_10;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    dispatch((0, actions_1.toggleLoading)({
                        spinning: true
                    }));
                    return [4, reward_service_1.RewardService.redeemRewardV2(rewardId, quantity)];
                case 1:
                    response = _a.sent();
                    dispatch({
                        type: (0, action_type_util_1.SUCCESS)(types_2.REDEEM_REWARD),
                        payload: response
                    });
                    dispatch((0, actions_2.fetchUserPoints)());
                    successCallback(response);
                    return [3, 4];
                case 2:
                    error_10 = _a.sent();
                    errorCallback(error_10);
                    dispatch({
                        type: (0, action_type_util_1.FAILURE)(types_2.REDEEM_REWARD),
                        payload: {
                            error: error_10
                        }
                    });
                    return [3, 4];
                case 3:
                    dispatch((0, actions_1.toggleLoading)({
                        spinning: false
                    }));
                    return [7];
                case 4: return [2];
            }
        });
    }); };
};
exports.redeemReward = redeemReward;
var resetReward = function () { return function (dispatch) {
    dispatch((0, actions_1.clearMessages)());
    dispatch({
        type: types_2.RESET_REWARD
    });
}; };
exports.resetReward = resetReward;
var claimFreeEntry = function (id, recaptcha, successCallback, errorCallback) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var freeEntriesRequestSubmission, now, response, error_11;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    freeEntriesRequestSubmission = getState().reward.freeEntriesRequestSubmission;
                    now = (0, moment_timezone_1.default)();
                    if (freeEntriesRequestSubmission && now.diff(freeEntriesRequestSubmission, 'seconds') < 60) {
                        errorCallback({ errorKey: 'error.reward.freeEntryTrace' });
                        return [2];
                    }
                    dispatch({
                        type: (0, action_type_util_1.REQUEST)(types_1.CLAIM_FREE_ENTRY)
                    });
                    return [4, reward_service_1.RewardService.claimFreeEntry(id, recaptcha)];
                case 1:
                    response = _a.sent();
                    dispatch({
                        type: (0, action_type_util_1.SUCCESS)(types_1.CLAIM_FREE_ENTRY),
                        payload: response
                    });
                    successCallback(response);
                    return [3, 3];
                case 2:
                    error_11 = _a.sent();
                    errorCallback(error_11);
                    dispatch({
                        type: (0, action_type_util_1.FAILURE)(types_1.CLAIM_FREE_ENTRY),
                        payload: {
                            error: error_11
                        }
                    });
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
};
exports.claimFreeEntry = claimFreeEntry;
var getPromotionByPromotionId = function (promotionId) { return __awaiter(void 0, void 0, void 0, function () {
    var error_12;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, services_1.PromotionsService.fetchPromotionDetails(promotionId)];
            case 1: return [2, _a.sent()];
            case 2:
                error_12 = _a.sent();
                console.error(error_12);
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
exports.getPromotionByPromotionId = getPromotionByPromotionId;
//# sourceMappingURL=action.js.map